// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimble-search .trimble-search-header {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.trimble-search .trimble-search-header .filter-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}

.trimble-search .trimble-search-header .filter-list .filter,
.trimble-search .trimble-search-header button.clear-filters {
  display: flex;
  height: 1.5rem;
  padding: 0 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  font-family: "Open Sans", sans-serif;
  color: var(--primary-black);
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.75rem;
  letter-spacing: 0.15px;
}

.trimble-search .trimble-search-header .filter-list .filter {
  border: 1px solid var(--primary-black);
  border-radius: 1000px;
}

.trimble-search .trimble-search-header button.clear-filters {
  border: 0;
  border-radius: 0.75rem;
  background: unset;
  gap: 0.25rem;
  cursor: pointer;
}

.trimble-search .trimble-search-header .filter-list .filter:hover,
.trimble-search .trimble-search-header button.clear-filters:hover {
  background-color: var(--button-hover-bg-color);
}

.trimble-search .trimble-search-header .filter-list .filter:focus,
.trimble-search .trimble-search-header button.clear-filters:focus {
  background: rgba(33, 124, 187, 0.3);
}

.trimble-search .trimble-search-header .filter-list .filter > .small-text {
  color: #363545;
  line-height: 2.5em !important;
}

.trimble-search .trimble-search-header .filter-list .filter:hover > .small-text,
.trimble-search .trimble-search-header .filter-list .filter:focus > .small-text {
  color: #ffffff;
}

.trimble-search .trimble-search-header .filter-list .filter svg {
  cursor: pointer;
}

/* PAGING INFO AND SORTING */

.trimble-search .trimble-search-header .paging-info > p {
  margin-top: 0;
  margin-bottom: 0;
}

.trimble-search .trimble-search-header .paging-info-and-sorting {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.trimble-search .sui-sorting {
  width: fit-content;
}

.trimble-search .sui-sorting .sui-select {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}

.trimble-search .sui-sorting .sui-select .sui-select__control {
  min-width: 160px;

  border-radius: 0.5rem;
  border: 1px solid rgba(22, 27, 29, 0.6);
  background-color: #ffffff;
  color: var(--primary-black);
}

.trimble-search .sui-sorting .sui-select .sui-select__control--is-focused {
  border: 2px solid rgba(22, 27, 29);
}

.trimble-search .sui-sorting .sui-select .sui-select__control--menu-is-open .sui-select__dropdown-indicator {
  transform: rotateX(0.5turn);
}

.trimble-search .sui-sorting .sui-select .sui-select__menu {
  border: 1px solid rgba(22, 27, 29, 0.6);
  border-radius: 0px !important;
  background-color: #fff !important;
  margin: 0;
  box-shadow: none;
}

.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__menu-list {
  padding: 0;
}

.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option {
  background-color: #fff !important;
}

.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option:hover,
.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option--is-focused {
  background-color: var(--button-hover-bg-color) !important;
}

/* RESPONSIVENESS */

@media (max-width: 800px) {
  .trimble-search .trimble-search-header {
    gap: 2rem;
  }

  .trimble-search .sui-sorting,
  .trimble-search .sui-sorting .sui-select .sui-select__control {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/results/header/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;;EAEZ,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;;EAEhB,qBAAqB;EACrB,uCAAuC;EACvC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,iCAAiC;EACjC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA,mBAAmB;;AAEnB;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".trimble-search .trimble-search-header {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.trimble-search .trimble-search-header .filter-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.trimble-search .trimble-search-header .filter-list .filter,\n.trimble-search .trimble-search-header button.clear-filters {\n  display: flex;\n  height: 1.5rem;\n  padding: 0 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n\n  font-family: \"Open Sans\", sans-serif;\n  color: var(--primary-black);\n  text-align: center;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 0.75rem;\n  letter-spacing: 0.15px;\n}\n\n.trimble-search .trimble-search-header .filter-list .filter {\n  border: 1px solid var(--primary-black);\n  border-radius: 1000px;\n}\n\n.trimble-search .trimble-search-header button.clear-filters {\n  border: 0;\n  border-radius: 0.75rem;\n  background: unset;\n  gap: 0.25rem;\n  cursor: pointer;\n}\n\n.trimble-search .trimble-search-header .filter-list .filter:hover,\n.trimble-search .trimble-search-header button.clear-filters:hover {\n  background-color: var(--button-hover-bg-color);\n}\n\n.trimble-search .trimble-search-header .filter-list .filter:focus,\n.trimble-search .trimble-search-header button.clear-filters:focus {\n  background: rgba(33, 124, 187, 0.3);\n}\n\n.trimble-search .trimble-search-header .filter-list .filter > .small-text {\n  color: #363545;\n  line-height: 2.5em !important;\n}\n\n.trimble-search .trimble-search-header .filter-list .filter:hover > .small-text,\n.trimble-search .trimble-search-header .filter-list .filter:focus > .small-text {\n  color: #ffffff;\n}\n\n.trimble-search .trimble-search-header .filter-list .filter svg {\n  cursor: pointer;\n}\n\n/* PAGING INFO AND SORTING */\n\n.trimble-search .trimble-search-header .paging-info > p {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.trimble-search .trimble-search-header .paging-info-and-sorting {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.trimble-search .sui-sorting {\n  width: fit-content;\n}\n\n.trimble-search .sui-sorting .sui-select {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__control {\n  min-width: 160px;\n\n  border-radius: 0.5rem;\n  border: 1px solid rgba(22, 27, 29, 0.6);\n  background-color: #ffffff;\n  color: var(--primary-black);\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__control--is-focused {\n  border: 2px solid rgba(22, 27, 29);\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__control--menu-is-open .sui-select__dropdown-indicator {\n  transform: rotateX(0.5turn);\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__menu {\n  border: 1px solid rgba(22, 27, 29, 0.6);\n  border-radius: 0px !important;\n  background-color: #fff !important;\n  margin: 0;\n  box-shadow: none;\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__menu-list {\n  padding: 0;\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option {\n  background-color: #fff !important;\n}\n\n.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option:hover,\n.trimble-search .sui-sorting .sui-select .sui-select__menu .sui-select__option--is-focused {\n  background-color: var(--button-hover-bg-color) !important;\n}\n\n/* RESPONSIVENESS */\n\n@media (max-width: 800px) {\n  .trimble-search .trimble-search-header {\n    gap: 2rem;\n  }\n\n  .trimble-search .sui-sorting,\n  .trimble-search .sui-sorting .sui-select .sui-select__control {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
